import View from "./View";

let Calendar = {
  View: View,
};

export default Calendar;
